$(document).ready(function () {
  $('#page-reload').click(function () {
    location.href = window.location;
  });
})

window.clearMsgInvalid = () => {
  $('.invalid-feedback').empty();
  $('.alert-danger').find('p').remove();
  $('.alert-danger').hide();
  $('.alert-success').find('p').remove();
  $('.alert-success').hide();
  $('.invalid-feedback').empty();
  $('input').removeClass('border border-danger');
  $('#profile').trigger("reset");;
}
